import React from 'react';

import { SimpleBarChart } from '@magoosh/lib/charts';

import StatisticData from '@test_prep/app/pages/analytics/components/statistic_data';

import loadingData from './loading_data';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  examName: string;
  filters: any;
}

const PerformanceBySectionChart: React.FC<Props> = (props) => {
  const loadingPlaceholder = (
    <SimpleBarChart
      colorPalette={{ dark: colors.gray85, light: colors.grayLightest }}
      data={loadingData(props.examName, props.filters.sections)}
      seriesNames={['Correct', 'Incorrect']}
    />
  );

  if (!props.filters) {
    return loadingPlaceholder;
  } else {
    return (
      <StatisticData
        filters={props.filters}
        name="performance_by_section"
      >
        <StatisticData.Loading>
          {loadingPlaceholder}
        </StatisticData.Loading>

        {/* @ts-ignore */}
        <SimpleBarChart
          colorPalette={{ dark: colors.dataDarkPurple, light: colors.dataMutedPurple }}
          seriesNames={['Correct', 'Incorrect']}
        />
      </StatisticData>
    );
  }
};

export default PerformanceBySectionChart;
